import { random } from 'lodash-es';

import type { PetitionDetailsPagePrefetchedContext } from '#src/app/pages/petitionDetails/pageContext';
import type { Sharer } from '#src/app/pages/petitionDetails/shared/types';
import type { LoadedStateData } from '#src/app/shared/utils/async';

// eslint-disable-next-line complexity
export function headlineReplacements({
	pageData,
	sharer,
	overrides,
}: {
	pageData: LoadedStateData<PetitionDetailsPagePrefetchedContext['pageData']>['pageData'];
	sharer?: Sharer;
	/** @deprecated no longer used — `displayName` now comes from GraphQL */
	i18n?: unknown;
	overrides?: {
		signatureCountLocalized?: string;
		signatureTargetLocalized?: string;
	};
}): Record<string, string | number> {
	const { petition } = pageData;
	const { signatureCount, signatureTargetLocalized } = petition.signatureState;

	return {
		// Random
		random_1_digit_number: random(1, 9),
		random_2_digit_number: random(10, 99),
		random_3_digit_number: random(100, 999),
		// Starter
		starter_name: petition.organization?.name || petition.user.displayName,
		starter_city_state: petition.user.formattedLocationString,
		starter_city_country: (() => {
			const { city } = petition.user;
			const countryName = petition.user.country?.displayName || '';
			return (city && countryName && `${city}, ${countryName}`) || '';
		})(),
		// Petition
		petition_name: petition.ask,
		petition_country: petition.country.displayName || '',
		petition_location: (() => {
			const { city } = petition;
			const stateShortDisplayName = petition.state?.shortDisplayName;
			const countryName = petition.country.displayName || '';
			const { formattedLocationString } = petition.user;
			const petitionLocation = [city, stateShortDisplayName, countryName].filter((v): v is string => !!v).join(', ');
			return petitionLocation || formattedLocationString;
		})(),
		// Sharer
		sharer_name: sharer?.displayName || '',
		sharer_name_short: sharer?.shortDisplayName || '',
		sharer_location: sharer?.formattedLocationString || '',
		preferredName: sharer?.shortDisplayName || '',
		preferred_name: sharer?.shortDisplayName || '',
		// DM
		petition_name_dm: petition.displayTitle,
		primary_dm_name: petition.dmsWithLegislativeBodiesConnection.nodes[0]?.decisionMakers[0]?.displayName || '',
		// Signatures
		signature_count: overrides?.signatureCountLocalized || signatureCount.displayedLocalized,
		signature_target: overrides?.signatureTargetLocalized || signatureTargetLocalized,
	};
}
